import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ColumnSortDirective } from './directives/column.sort.directive';
import { TableRowDirective } from './directives/table-row.directive';
import { TableTemplate } from './directives/table-template.directive';
import { TableComponent } from './table.component';
import { TableService } from './table.service';
import { SplitCommaPipe } from './split-comma.pipe';
import { CampaignCodePipe } from './pipes/campaignCodePipe/campaign-code.pipe';

@NgModule({
  declarations: [TableComponent, ColumnSortDirective, TableTemplate, SplitCommaPipe, CampaignCodePipe],
  providers: [TableService],
  imports: [CommonModule, FormsModule],
  exports: [TableComponent, ColumnSortDirective, TableTemplate, SplitCommaPipe, CampaignCodePipe],
})
export class TableModule {}
